import { type ConversationAPIPayloadType } from 'views/Chatbot/types/chatbot.request.types';
import BaseAPI from './base.api';

export default class ChatbotAPI extends BaseAPI {
  conversation = async (payload: ConversationAPIPayloadType) => {
    const response = await this.API.post('chat/query', payload);
    return response.data;
  };
}
